type Props = {
  label?: string
  className?: string
}

export const Separator = ({ className, label }: Props) => (
  <div className={className} data-testid='separator'>
    <div className='relative'>
      <div aria-hidden='true' className='absolute inset-0 flex items-center'>
        <div className='border-border-default w-full border-t' />
      </div>
      <div className='relative flex justify-center text-sm font-medium leading-6'>
        {label ? <span className='bg-background-alternative text-text-alternative px-5'>{label}</span> : null}
      </div>
    </div>
  </div>
)
